import { Injectable } from '@angular/core';
import { Article } from '@article/const';
import { ArticleService } from '@article/feature';
import { WindowRef } from '@spartacus/core';
import { SchemaBuilder } from '@spartacus/storefront';
import { map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ArticleDetailSchemaBuilder implements SchemaBuilder {
  constructor(
    private articleService: ArticleService,
    private winRef: WindowRef,
  ) {}

  build(): Observable<Record<string, any>> {
    return this.articleService.getCurrentArticle().pipe(
      map((article) => {
        if (article) {
          return this.collect(article);
        }

        return of({});
      }),
    );
  }

  protected collect(article: Article): Record<string, any> {
    return {
      '@context': 'http://schema.org',
      '@type': 'Article',
      name: article.name,
      description: article.description,
      datePublished: article.publishDate,
      dateModified: article.updateDate,
      inLanguage: 'ru-RU',
      keywords: article.keywords,
      thumbnailUrl: article.picture?.url,
      image: article.picture?.url,
      url: this.winRef.location.href,
    };
  }
}
